import { temAcesso } from '@/shared/auth/temAcesso'

const Apoios = () => import('./Apoios.vue')

export default {
    path: 'apoios',
    name: 'Gescon_Gerentes_Apoios',
    component: Apoios,
    beforeEnter: (to, from, next) => {
        if (temAcesso('GESCON-GER-APOIO-00')) {
            next()
        }
    }
}
